import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addTaskReminder, getTaskReminder, updateTaskReminder, deleteTaskReminder} from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class TaskReminder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            taskreminder: ''
        }
        this.handleTaskReminderSubmit = this.handleTaskReminderSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (taskreminder) => {
        this.setState({ taskreminder: taskreminder });
        this.setState({ deleteModal: true });
    };

    handleDeleteTaskReminder = () => {
        const { onDeleteTaskReminder } = this.props;
        const { taskreminder } = this.state;

        if (taskreminder.id !== undefined) {
            onDeleteTaskReminder(taskreminder);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleTaskReminderSubmit(value) {
        this.props.addTaskReminder(value, this.props.history);
    }

    componentDidMount() {
        const { onGetTaskReminder } = this.props;
        onGetTaskReminder(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { taskreminders } = this.props;
        if (!isEmpty(taskreminders) && size(prevProps.taskreminders) !== size(taskreminders)) {
            this.setState({ taskreminders: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ taskreminder: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const taskreminder = arg;
        this.setState({
            taskreminder: {
                id: taskreminder.id,
                taskReminderId: taskreminder.taskReminderId,
                taskReminderTitle:taskreminder.taskReminderTitle,
                agentId: taskreminder.agentId
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { taskreminders, onUpdateTaskReminder } = this.props;
        const { isEdit, deleteModal } = this.state;
        const taskreminder = this.state.taskreminder;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteTaskReminder}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Task Reminder")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        taskReminderTitle: (this.state && this.state.taskReminderTitle) || "",
                                    

                                    }}
                                    validationSchema={Yup.object().shape({
                                       
                                        taskReminderTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleTaskReminderSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Task Reminder</CardTitle>
                                                    <Row>

                                                   
                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="taskReminderTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="taskReminderTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.taskReminderTitle && touched.taskReminderTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="taskReminderTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="taskReminderTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title"> History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(taskreminders, (taskreminder, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                       
                                                                        <td>{taskreminder.taskReminderTitle}</td>
                                                                        <td>
                                                                        <ActionEdit onClick={() => this.toggleRightCanvas(taskreminder)} />
                                                                        <ActionDelete onClick={() => this.onClickDelete(taskreminder)} />
                                                                           

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: taskreminder.id,
                                            taskReminderId: taskreminder.taskReminderId,
                                            taskReminderTitle:taskreminder.taskReminderTitle,
                                            agentId: taskreminder.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        
                                        taskReminderTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                            taskReminderId: values.taskReminderId,
                                            taskReminderTitle:values.taskReminderTitle,
                                            agentId: values.agentId
                                            };
                                            onUpdateTaskReminder(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                        
                                                        <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="taskReminderTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="taskReminderTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.taskReminderTitle && touched.taskReminderTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="taskReminderTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="taskReminderTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
TaskReminder.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addTaskReminder: PropTypes.func,
    onGetTaskReminder: PropTypes.func,
    taskreminders: PropTypes.array,
    onDeleteTaskReminder: PropTypes.func,
    onUpdateTaskReminder: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        taskreminders: AppoinmentObject.taskreminders,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addTaskReminder: (data) => dispatch(addTaskReminder(data)),
    onGetTaskReminder: (agentId) => dispatch(getTaskReminder(agentId)),
    onDeleteTaskReminder: (id) => dispatch(deleteTaskReminder(id)),
    onUpdateTaskReminder: (data) => dispatch(updateTaskReminder(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TaskReminder))
